import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { ReactNode, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/react';
import { selectUserEmail } from 'src/store/entities/user/selectors';
import type { TRootState } from 'src/store/store-types';

type TSentryConfigurationProps = {
  children: ReactNode;
  userEmail: string;
};

const RawSentryConfiguration = ({ children, userEmail }: TSentryConfigurationProps) => {
  useEffect(() => {
    if (userEmail && Sentry.getClient()) {
      Sentry.setUser({ email: userEmail });
    }
  }, [userEmail]);

  return children;
};

const mapStateToProps = (state: TRootState) => ({
  userEmail: selectUserEmail(state),
});

export const SentryConfiguration = withErrorBoundary(connect(mapStateToProps)(RawSentryConfiguration));
